import { lazy } from "react";
import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";
import ApproveCommit from "./ApproveCommitDialog";
import RejectCommit from "./RejectCommitDialog";
import AssignAgency from "./AssignAgencyDialog";
import AgencyDetails from "./agencyDetails";
import AddDisbursment from "./AddDisbursment";
import AddFundUtilizationDialog from "./FundUtilised";
import AgencyAccept from "./AgencyAccept";



const CommitmentModule = lazy(() => import("./CommitmetDialog"));
const ApprovalDialog = lazy(() => import("./ApproveRejectDialog"));
const KPIForm = lazy(() => import("./KPIFeedback"));
const CreateProjectLocation = lazy(() => import("./CreateProjectLocation"));
const ConfirmInterest = lazy(() => import("./ShowInterstDialog"));
const ConfirmMilestoneComplete = lazy(() => import("./ConfirmMilestoneComplete"));
const ConfirmProjectComplete = lazy(() => import("./ConfirmProjectComplete"));
const MOUDialog = lazy(() => import("./MOUDialog"));




const dialogsTypesWise: any = {
  
  "commitmentform": () => <CommitmentModule/>,
  "approverejectdialog": () => <ApprovalDialog />,
  "kpiFeedback": () => <KPIForm />,
  "editkpi": () => <KPIForm />,
  "createProjectLocation": () => <CreateProjectLocation />,
  "showInterest": () => <ConfirmInterest />,
  "approvedCommit": () => <ApproveCommit />,
  "acceptAgency": () => <AgencyAccept />,
  "rejectAgency": () => <AgencyAccept />,
  "rejectCommit": () => <RejectCommit />,
  "assignAgency": () => <AssignAgency />,
  "showAgencyDetails": () => <AgencyDetails />,
  "disbursementform" : ()=> <AddDisbursment/>,
  "fundUtilisedform" : ()=> <AddFundUtilizationDialog/>,
  "milstoneConfirmation" : ()=> <ConfirmMilestoneComplete />,
  "projectCompleteConfirmation" : ()=> <ConfirmProjectComplete />,
  "UploadMOUDocument" : ()=> <MOUDialog />
}

const dialogTypeFullScreen: any = {

}

const ProjectMasterPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            { dialogsTypesWise[type]?.() ?? null }
                        </>
                    )
            }
        </>
    )
}
export default ProjectMasterPage;



